import {
    TextVerticalAlignBottomIcon,
    TextVerticalAlignCenterIcon,
    TextVerticalAlignTopIcon,
} from "@/icons/widget-menu";

export const TEXT_VERTICAL_ALIGN_ICONS = {
    top: TextVerticalAlignTopIcon,
    center: TextVerticalAlignCenterIcon,
    bottom: TextVerticalAlignBottomIcon,
};
